module.exports = __webpack_public_path__ + "img/campaign_h_bg.b5a7a628.png";